import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Card } from 'react-bootstrap';
import { getSubcontractors, deleteSubcontractor } from '../../../../services/SubcontractorService';

const SubcontractorList = () => {
  const [subcontractors, setSubcontractors] = useState([]);

  useEffect(() => {
    getSubcontractors()
      .then((data) => setSubcontractors(data))
      .catch((error) => console.error(error));
  }, []);

  const onDelete = (id) => {
    deleteSubcontractor(id)
      .then(() => setSubcontractors(subcontractors.filter((s) => s._id !== id)))
      .catch((error) => console.error(error));
  };

  return (
    <div>
      <Card className="p-3">
        <h2 style={{ color: 'black' }}>Subcontractors</h2>
        <div className="d-flex justify-content-end">
          <Link to="/settings/subcontractor/add">
            <Button variant="primary" className="mb-3">
              Add Subcontractor
            </Button>
          </Link>
        </div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Program</th>
              <th>Name</th>
              <th>Number</th>
              <th>POC Name</th>
              <th>POC Email</th>
              <th>POC Phone</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {subcontractors.length > 0 ? (
              subcontractors.map((s) => (
                <tr key={s._id}>
                  <td>{s.program}</td>
                  <td>{s.name}</td>
                  <td>{s.number}</td>
                  <td>{s.pocname}</td>
                  <td>{s.pocemail}</td>
                  <td>{s.pocphone}</td>
                  <td>
                    <Link to={`/settings/subcontractor/edit/${s._id}`}>
                      <Button
                        variant="warning"
                        title="Edit"
                        className="btn btn-primary shadow btn-xs sharp me-1"
                        style={{ background: '#3a7afe', border: 'none' }}
                      >
                        <i className="fa fa-pencil"></i>
                      </Button>
                    </Link>{' '}
                    <Button
                      onClick={() => onDelete(s._id)}
                      title="Delete"
                      className="btn btn-danger shadow btn-xs sharp"
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No subcontractors found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>
    </div>
  );
};

export default SubcontractorList;
